import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { useEffect, useState } from "react";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { editCell, getBuzzList } from "../../util/APIUtils";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

const options = {
  sortIndicator: true,
  hideSizePerPage: false,
  paginationSize: 3,
  hidePageListOnlyOnePage: false,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};

export default function ExpenseBody({
  data,
  open,
  toggle,
  selectedOption,
  contextMenuPosition,
  handleRightClick,
  currentRow,
}) {
  const cellButton = (cell, row, enumObject, rowIndex) => {
    return (
      <span>
        <Button
          className="btn btn-warning"
          id={"more" + rowIndex}
          onClick={(e) => handleRightClick(e, row)}
          style={{ marginLeft: "5px" }}
        >
          <i className="fa fa-ellipsis-v" />
        </Button>
      </span>
    );
  };
  return (
    <span>

      <BootstrapTable
        data={data}
        version="4"
        condensed={true}
        striped
        hover
        pagination
        search
        options={options}
        exportCSV
        csvFileName="expenses.csv"
      >
        <TableHeaderColumn
          isKey
          dataField="id"
          export={false}
          hidden={true}
        >
          ID
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="categoryName"
          csvHeader="categoryName"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
        >
          Category Name
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="updatedAt"
          csvHeader="updatedAt"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
          dataFormat={(cell) => cell.substring(0, 10)}

        >
          UpdatedAt
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="payeeName"
          csvHeader="payeeName"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
        >
          Payee Name
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="expenseDate"
          csvHeader="expenseDate"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
        >
          Expense Date
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="amount"
          csvHeader="bankamountName"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
          editable={true}
        >
          Amount
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="paymentType"
          csvHeader="paymentType"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
        >
          Payment Type
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="description"
          csvHeader="description"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
        >
          Description
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="moc"
          csvHeader="moc"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
        >
          MOC
        </TableHeaderColumn>

        {/* <TableHeaderColumn
              dataField="button"
              dataFormat={cellButton}
              hiddenOnInsert
              export={false}
            >
              Actions
            </TableHeaderColumn> */}
      </BootstrapTable>
      {open && (
        <Dropdown
          isOpen={open}
          toggle={() => toggle()}
          style={{
            position: "fixed",
            top: contextMenuPosition.y,
            left: contextMenuPosition.x,
          }}
        >
          <DropdownToggle
            tag="span"
            data-toggle="dropdown"
            aria-expanded={true}
          />
          <DropdownMenu>
            <DropdownItem
              onClick={() => selectedOption(1)}
              disabled={currentRow.paymentType != "CHEQUE"}
            >
              Cheque Return
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      )}
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/ExpenseBody.js